import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import * as moment from "moment-timezone";
import {Moment} from "moment-timezone";
import {ApiService} from "../services/api.service";

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss']
})
export class CalendarComponent implements OnInit {

  public freeSlots: Array<any> =  [];

  public current: any;

  public date = moment();

  public currentDay: any;

  public days: Array<any> =  [];

  public types: any;

  public type: any = 1;

  public year: Array<any> = ["Leden","Únor","Březen","Duben","Květen","Červen","Červenec","Srpen","Září","Říjen","Listopad","Prosinec"];

  // public daysarr = this.createCalendar(this.date);
  @Output() DateSelect = new EventEmitter();

  @Output() TypeSelect = new EventEmitter();

  constructor(private _apiService: ApiService) { }

  // createCalendar( month : string )
  // {
  //   let firstDay = moment(month).startOf('M');
  //   let days = Array.apply(null,{length: month.daysInMonth()+1})
  //              .map(Number.call, Number)
  //              .slice(1);
  //   for(let n=0; n < firstDay.weekday(); n++)
  //   {
  //     days.unshift(null);
  //
  //   }
  //   return days;
  // }

  ngOnInit(): void {
    // this.daysarr = this.createCalendar(this.date);
    this.loadFreeSlots(this.type);
    this.generateDays();
    this.loadTypes();
    this.TypeSelect.emit(this.type);
  }

  private loadFreeSlots(type: any){
    this._apiService.getFreeTermsSummary(type, moment(this.date).startOf('month').toDate(), moment(this.date).endOf( 'month').toDate()).subscribe((response: any) => {
      this.freeSlots = response;
    });
  }

  public findFree(day: string): number {
    const found = this.freeSlots.filter((item) => { return item.date == day; });
    if(found.length > 0)
      return found[0].count;
    return 0;
  }

  private loadTypes(){
    this._apiService.getReservationType().subscribe((response: any) => {
      this.types = response;
    });
  }

  public dateNumber(day: string){
    var dayNumber = moment(day).format("D");
    return dayNumber;
  }

  public nextMonth(){
    this.date.add(1, 'M');
    this.loadFreeSlots(this.type);
    this.generateDays();
  }

  public prevMonth(){
    this.date = this.date.subtract(1, 'M');
    this.loadFreeSlots(this.type);
    this.generateDays();
  }

  get daysCount(): number{
    return moment(this.date, "YYYY-MM").daysInMonth();
  }

  public generateDays(){
    var daysInMonth = moment(this.date, "YYYY-MM").daysInMonth();
    var arrDays = [];



    while(daysInMonth) {
      var dayStep;
      dayStep = moment(this.date).format("YYYY-MM-").toString()+daysInMonth;
      var current = moment(dayStep,"YYYY-MM-DD");
      arrDays.push( moment(current).format("YYYY-MM-DD") );
      daysInMonth--;
    }

    this.days = arrDays.reverse();
  }

  get startDay(): number{

    var start;

    start = this.date.startOf('month').day();

    if(start == 0){

      return 6;

    }else{

      return start-1;

    }

  }

  get monthName(){
    // return this.date.lang("cs").format('MMMM YYYY');
    let monthNumber:any = this.date.lang("cs").format('M');
    let monthNameString = this.year[monthNumber - 1];
    let year = this.date.format(' YYYY');
    return monthNameString+year;
  }

  //
  // public nextmonth()
  // {
  //   this.date.add(1,'M');
  //   this.daysarr = this.createCalendar(this.date);
  // }
  //
  // public previousmonth()
  // {
  //   this.date.subtract(1,'M');
  //   this.daysarr = this.createCalendar(this.date);
  //
  // }

  onSelectDay(day: any){
    this.DateSelect.emit(day);
    this.currentDay = day;
  }

  changeType(typeId: any){
    this.type = typeId;
    this.loadFreeSlots(this.type);
    this.TypeSelect.emit(typeId);
  }

  compareDays(dayA:any, dayB:any){

    if(moment(dayA).format('DD-MM-YYYY') == moment(dayB).format('DD-MM-YYYY')){
      return true;
    }else{
      return false;
    }

  }

}
